/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * CalendarIcon
 */
export default class CalendarIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M19 3h-2V2c0-.6-.4-1-1-1s-1 .4-1 1v1H9V2c0-.6-.4-1-1-1s-1 .4-1 1v1H5C3.3 3 2 4.3 2 6v14c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3V6c0-1.7-1.3-3-3-3zM5 5h2v1c0 .6.4 1 1 1s1-.4 1-1V5h6v1c0 .6.4 1 1 1s1-.4 1-1V5h2c.6 0 1 .4 1 1v3H4V6c0-.6.4-1 1-1zm15 6v9c0 .6-.4 1-1 1H5c-.6 0-1-.4-1-1v-9h16zM7.75 17h-1.5a1 1 0 00-.117 1.993L6.25 19h1.5a1 1 0 000-2zm5 0h-1.5a1 1 0 000 2h1.5a1 1 0 000-2zm-5-4h-1.5a1 1 0 00-.117 1.993L6.25 15h1.5a1 1 0 000-2zm5 0h-1.5a1 1 0 00-.117 1.993l.117.007h1.5a1 1 0 000-2zm5 0h-1.5a1 1 0 00-.117 1.993l.117.007h1.5a1 1 0 000-2z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

